// extracted by mini-css-extract-plugin
export default {"lockIcon":"styles_lockIcon__42Whk","totalPriceWrapper":"styles_totalPriceWrapper__cSNDd"};